/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { makeDecorator, makeParamDecorator } from "../util/decorators";
/**
 * Type of the Inject decorator / constructor function.
 *
 * \@stable
 * @record
 */
export function InjectDecorator() { }
function InjectDecorator_tsickle_Closure_declarations() {
    /* TODO: handle strange member:
    (token: any): any;
    */
    /* TODO: handle strange member:
    new (token: any): Inject;
    */
}
/**
 * Inject decorator and metadata.
 *
 * \@stable
 * \@Annotation
 */
export var /** @type {?} */ Inject = makeParamDecorator('Inject', function (token) { return ({ token: token }); });
/**
 * Type of the Optional decorator / constructor function.
 *
 * \@stable
 * @record
 */
export function OptionalDecorator() { }
function OptionalDecorator_tsickle_Closure_declarations() {
    /* TODO: handle strange member:
    (): any;
    */
    /* TODO: handle strange member:
    new (): Optional;
    */
}
/**
 * Optional decorator and metadata.
 *
 * \@stable
 * \@Annotation
 */
export var /** @type {?} */ Optional = makeParamDecorator('Optional');
/**
 * Type of the Injectable decorator / constructor function.
 *
 * \@stable
 * @record
 */
export function InjectableDecorator() { }
function InjectableDecorator_tsickle_Closure_declarations() {
    /* TODO: handle strange member:
    (): any;
    */
    /* TODO: handle strange member:
    new (): Injectable;
    */
}
/**
 * Injectable decorator and metadata.
 *
 * \@stable
 * \@Annotation
 */
export var /** @type {?} */ Injectable = makeDecorator('Injectable');
/**
 * Type of the Self decorator / constructor function.
 *
 * \@stable
 * @record
 */
export function SelfDecorator() { }
function SelfDecorator_tsickle_Closure_declarations() {
    /* TODO: handle strange member:
    (): any;
    */
    /* TODO: handle strange member:
    new (): Self;
    */
}
/**
 * Self decorator and metadata.
 *
 * \@stable
 * \@Annotation
 */
export var /** @type {?} */ Self = makeParamDecorator('Self');
/**
 * Type of the SkipSelf decorator / constructor function.
 *
 * \@stable
 * @record
 */
export function SkipSelfDecorator() { }
function SkipSelfDecorator_tsickle_Closure_declarations() {
    /* TODO: handle strange member:
    (): any;
    */
    /* TODO: handle strange member:
    new (): SkipSelf;
    */
}
/**
 * SkipSelf decorator and metadata.
 *
 * \@stable
 * \@Annotation
 */
export var /** @type {?} */ SkipSelf = makeParamDecorator('SkipSelf');
/**
 * Type of the Host decorator / constructor function.
 *
 * \@stable
 * @record
 */
export function HostDecorator() { }
function HostDecorator_tsickle_Closure_declarations() {
    /* TODO: handle strange member:
    (): any;
    */
    /* TODO: handle strange member:
    new (): Host;
    */
}
/**
 * Host decorator and metadata.
 *
 * \@stable
 * \@Annotation
 */
export var /** @type {?} */ Host = makeParamDecorator('Host');
//# sourceMappingURL=metadata.js.map


// WEBPACK FOOTER //
// ../../../packages/core/esm5/src/di/metadata.js